import { CheckboxListOption } from '@creditsights/styleguide-web/components/CheckboxList/CheckboxList.types';
import { PageComponentsMap } from '../../../models';
import { IssuerDto } from '../../../services/dtos/issuer/issuer.dto';
import {
  DYNAMIC_PRINTABLE_SECTIONS,
  PRINTABLE_SECTIONS_WITHOUT_CS_COVERAGE,
  STATIC_PRINTABLE_SECTIONS,
} from './CompanyPrintAction.constants';

export const getAvailableWidgetsByCompany = (
  company: IssuerDto,
  pageComponentsMap: PageComponentsMap
): CheckboxListOption[] => {
  if (!company.csCoverage) {
    return PRINTABLE_SECTIONS_WITHOUT_CS_COVERAGE;
  }

  const dynamicSections = DYNAMIC_PRINTABLE_SECTIONS.filter((section) => !!pageComponentsMap[section]).map(
    (section) => ({
      id: section,
      label: pageComponentsMap[section]!.title,
    })
  );
  return dynamicSections.concat(Object.values(STATIC_PRINTABLE_SECTIONS));
};
